import FunnelStepActions from 'modules/funnels/funnel/components/funnel-actions'
import TestsIcon from 'modules/funnels/funnel/icons/tests-icon'
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface'
import { getFunnelStepTypeIcon } from 'modules/funnels/funnel/utils/get-funnel-step-type-icon'
import React from 'react'
import { FunnelStepTypeTitlesEnum } from 'shared/enums/funnel-step-type-enum'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { CheckIcon } from '@systemeio/ui/icons'

interface OverlayFunnelStepProps {
  funnelStep?: FunnelStepInterface
}

function OverlayFunnelStep({ funnelStep }: OverlayFunnelStepProps) {
  const { t } = useLocoTranslation()

  if (!funnelStep) {
    return null
  }

  return (
    <li className="hover:bg-brand-primary/[0.06] border-[rgb(var(--text-primary))]/20 flex cursor-pointer justify-between border-b-[1px] px-8 py-7 last:border-b-transparent">
      <div className="flex gap-3">
        {getFunnelStepTypeIcon(funnelStep.type)}
        <div className="flex flex-col">
          <span className={`text-base font-bold`}>{funnelStep.name}</span>
          <span className="text-sm font-normal">
            {t(FunnelStepTypeTitlesEnum[funnelStep.type])}
          </span>
        </div>
      </div>
      {funnelStep.goalFunnelStepOfAnySplitTest && (
        <div className="absolute left-3 top-3">
          <CheckIcon className="stroke-[rgb(var(--fill-primary))] h-4 w-4" />
        </div>
      )}
      {funnelStep.inRunningSplitTest && (
        <div className="absolute left-3 top-3">
          <TestsIcon className="stroke-[rgb(var(--fill-primary))] h-4 w-4" active={false} />
        </div>
      )}
      <FunnelStepActions funnelStep={funnelStep} />
    </li>
  )
}

export default OverlayFunnelStep
